import { PDF_VIEWER_ROUTE } from "../../../shared/reservedRoutes";
import { baseMediaType } from "../../../shared/attachmentPolicy";
import { openIsolatedFrame } from "../../lib/openIsolatedFrame";
import { pdfPreviewOrigin } from "../../lib/pdfPreviewOrigin";

export function openIsolatedPdf(
  source: Blob | string,
  title: string,
  edgeOrigin: string
) {
  const origin = pdfPreviewOrigin(edgeOrigin);
  if (!origin) return;
  const viewer = openIsolatedFrame(title, `${origin}${PDF_VIEWER_ROUTE}`, null);
  if (!viewer) return;
  const { popup, frame } = viewer;
  frame.addEventListener(
    "load",
    () => {
      const pdf =
        typeof source === "string"
          ? fetch(source, { credentials: "include" }).then((response) =>
              response.ok ? response.blob() : undefined
            )
          : Promise.resolve(source);
      void pdf
        .then((blob) => {
          if (!blob || baseMediaType(blob.type) !== "application/pdf") {
            popup.document.body.textContent = "Couldn’t open this PDF";
            return;
          }
          frame.contentWindow?.postMessage(
            blob.slice(0, blob.size, "application/pdf"),
            origin
          );
        })
        .catch(() => {
          popup.document.body.textContent = "Couldn’t open this PDF";
        });
    },
    { once: true }
  );
  popup.document.body.appendChild(frame);
}
